/**
 * Which surface is rendering a property hero (not-found / load-error).
 *
 * The heroes take this rather than a `backLabel` string, because their BODY
 * COPY has to follow the surface too — not just the button. DV-2849's first
 * cut parameterised the label alone, which left the internal console saying
 * "Try again, or return to your properties" above a button reading "Back to
 * Global Orders", and telling internal editors "This property doesn't exist or
 * may have been removed" (the single-org customer sentence) on a surface that
 * has no orgs, about properties that mostly do exist — the workspace's own
 * spec lists that hero as the EXPECTED state for every client property until
 * property-service PR #466 deploys. One prop makes the two impossible to
 * disagree (PR #1159 review).
 *
 * Same values as `AssetsEntry` in `usePropertyAssets`, which aliases this;
 * the heroes are also rendered by property-detail, so the type lives here
 * rather than in the assets feature.
 */
export type PropertyEntry = 'account' | 'global-orders';

/** Back-button label for each surface; the heroes' only labelling rule. */
export const backLabelFor = (entry: PropertyEntry): string =>
  entry === 'global-orders' ? 'Back to Global Orders' : 'Back to Properties';
